<template>
    <div class="profile-page">
        <v-container>
            <h1 class="title">Profile</h1>
            
            <v-divider />
            
            <v-form class="mt-5">
                <v-text-field
                    v-model="form.username"
                    label="Username"></v-text-field>
                

                <v-text-field
                    v-model="form.first_name"
                    label="First Name"></v-text-field>
                

                <v-text-field
                    v-model="form.last_name"
                    label="Last Name"></v-text-field>

                <v-text-field
                    disabled
                    :value="form.login_type"
                    label="Login Service"></v-text-field>

                <v-text-field
                    disabled
                    :value="form.email"
                    label="E-mail"></v-text-field>

                <div>
                    <v-btn
                        class="mr-1"
                        outlined
                        @click="toggleChangePasswordPanel()">
                        Change Password
                    </v-btn>
                    <v-btn
                        outlined
                        color="success"
                        @click="update">
                        Update
                    </v-btn>
                </div>
            </v-form>
        </v-container>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    data() {
        return {
            isPasswordModalActive: false,
            isShowPasswordPanel: false,
            form: {
                name: '',
                email: '',
                password: ''
            }
        }
    },
    async beforeMount() {
        const result = await this.$axios.get(`/users/${this.account.id}`);
        this.form = Object.assign({}, result.data);
        this.form.id = +this.form.id;
    },
    methods: {
        async update() {
            try {
                const result = await axios.put(`/users/${this.account.id}`, this.form);
            } catch (e) {
                console.error(e);
            }
        },
        toggleChangePasswordPanel() {
            this.isShowPasswordPanel = !this.isShowPasswordPanel;

            if (!this.isShowPasswordPanel) {
                this.form.password = '';
            }
        }
    },
    computed: {
        account() {
            return this.$store.state.account;
        }
    }
}
</script>